import React from 'react';
import { observer } from 'mobx-react-lite';
import { DiscountFormController } from 'store/modules/override-rates/ratesOverriderDelegate';
import { DiscountFormStyled, IMInputTextStyled, IMSubmitButtonStyled } from './styles';
import { APPLY_DISCOUNT_FORM_ID } from '../constants';

interface Props {
  formController: DiscountFormController;
}

export const ApplyDiscountForm: React.FC<Props> = observer(({ formController }) => {
  return (
    <DiscountFormStyled formController={formController} id={APPLY_DISCOUNT_FORM_ID}>
      <IMInputTextStyled label="Discount" name="discount" additionalOptions={{ contributionType: 'percentage' }} />
      <IMSubmitButtonStyled type="opaque" color="primary" size="large">
        Apply Discount
      </IMSubmitButtonStyled>
    </DiscountFormStyled>
  );
});
